const SeychellesSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112316)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M33.5006 5.24508C29.9428 1.98789 25.2037 0 19.9999 0C19.148 0 18.3086 0.0536719 17.4847 0.157031L7.82602 11.3044L0.632812 25.0102C1.0975 26.8119 1.80797 28.5145 2.72461 30.0819L19.9999 20L33.5006 5.24508Z"
        fill="#FFDA44"
      />
      <path
        d="M36.6513 31.0811L8.66943 36.4811C11.8904 38.6999 15.7934 40 20.0004 40C26.9474 40 33.0661 36.4575 36.6513 31.0811Z"
        fill="#6DA544"
      />
      <path
        d="M33.5037 5.24902L2.73633 30.1025C3.54109 31.475 4.50461 32.7431 5.60203 33.8813L40.0002 20.0013C40.0002 14.1607 37.4963 8.90543 33.5037 5.24902Z"
        fill="#D80027"
      />
      <path
        d="M0 19.9992C0 21.7295 0.219844 23.4083 0.632891 25.0095L17.4848 0.15625C7.62641 1.39328 0 9.80547 0 19.9992Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112316">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SeychellesSvg;
